// FAZ-53 — Çağrı merkezi (kulaklık) ikonu.
//
// Heroicons v2'de kulaklık/headset ikonu YOK; telefon ikonu ise "arama" demek,
// "çağrı merkezinden alındı" demiyor. Bu yüzden heroicons outline diliyle
// (24x24 viewBox, stroke=currentColor, stroke-width 1.5, yuvarlak uçlar)
// uyumlu özel bir ikon çizildi.
//
// Biçim: baş üstü bant (kemer) + iki kulaklık yastığı + mikrofon kolu.

import React from "react";

export default function HeadsetIcon({ className = "", ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      data-icon="headset"
      {...rest}
    >
      {/* Kemer: kulaktan kulağa yay */}
      <path d="M4 13v-1a8 8 0 0 1 16 0v1" />
      {/* Sol kulaklık yastığı */}
      <path d="M4 13h1.5A1.5 1.5 0 0 1 7 14.5v2.5A1.5 1.5 0 0 1 5.5 18.5H5A2 2 0 0 1 3 16.5v-1.5A2 2 0 0 1 4 13Z" />
      {/* Sağ kulaklık yastığı */}
      <path d="M20 13h-1.5A1.5 1.5 0 0 0 17 14.5v2.5a1.5 1.5 0 0 0 1.5 1.5h.5a2 2 0 0 0 2-2v-1.5a2 2 0 0 0-1-1.5Z" />
      {/* Mikrofon kolu + ağızlık */}
      <path d="M20 18.5v.5a2.5 2.5 0 0 1-2.5 2.5H14" />
      <circle cx="12.4" cy="21.5" r="1.1" />
    </svg>
  );
}
